
import axios from './$http'



export const getIconList = () => {
  return axios.get("/sys-dict/subject/logos")
}